import { formatDate } from "../formatters";

export default function TicketStatusHistory({ entries, userRole }) {
  const isClient = userRole === "client";

  return (
    <div className="support-ticket-panel">
      <h3 className="heading-3">Historique des statuts</h3>
      {entries.map((entry) => (
        <div
          key={entry.id}
          className={`support-history-item${isClient ? " is-client-view" : ""}`}
        >
          <div>
            <strong>{entry.label}</strong>
            {!isClient && (
              entry.comment ? (
                <div
                  className="support-rich-content"
                  dangerouslySetInnerHTML={{ __html: entry.comment }}
                />
              ) : (
                <p>Sans commentaire</p>
              )
            )}
          </div>
          <small>
            {isClient
              ? formatDate(entry.changed_at)
              : `${entry.changed_by} - ${formatDate(entry.changed_at)}`}
          </small>
        </div>
      ))}
    </div>
  );
}
